export default {
	products: [],
	proccessId: [],
	//token: null,
	loaded: true
}